import httpService from '@/api/httpService'

const ShipmentApi = (() => {
  const apiPostfix = 'documents'

  return {
    apiPostfix: apiPostfix,

    async getDocuments () {
      const response = await httpService.get(`delivery/${apiPostfix}/shipment`)
      return response.data
    }
  }
})()

export default ShipmentApi
